import { render } from "./MainTitle.vue?vue&type=template&id=0c10a2ad&scoped=true&ts=true"
import script from "./MainTitle.vue?vue&type=script&lang=ts"
export * from "./MainTitle.vue?vue&type=script&lang=ts"

import "./MainTitle.vue?vue&type=style&index=0&id=0c10a2ad&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c10a2ad"]])

export default __exports__